var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2a8 8 0 0 0-8 8c0 3.1 2 6.1 4.2 8.4a29.4 29.4 0 0 0 3.8 3.4 27.3 27.3 0 0 0 3.8-3.4C18 16.1 20 13.1 20 10a8 8 0 0 0-8-8Zm0 21-.6.8a9.7 9.7 0 0 1-.4-.3 28.5 28.5 0 0 1-4.2-3.7C4.5 17.4 2 14 2 10a10 10 0 0 1 20 0c0 3.9-2.5 7.4-4.8 9.8a31.4 31.4 0 0 1-4.6 4L12 23Zm0 0 .6.8a1 1 0 0 1-1.2 0l.6-.8Zm0-15a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
  fill: "currentColor"
})));
export default SvgMarker;